import rootAxios from '../../requests/rootAxios';

export const submitFeedback = async (suggestion) => {
  try {
    const response = await rootAxios.post('/user/submit-monthly-suggestion', {
      suggestion,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
